import { ADICIONAR_DADOS_CTE_ENCOMENDA } from '../types'

export default function adicionarDadosCteEncomenda (dadosCte) {
  return {
    type: ADICIONAR_DADOS_CTE_ENCOMENDA,
    payload: dadosCte
  }
}
